import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import { RootState } from 'store';

import { searchCitiesAutocomplete } from 'actions/citiesAutocomplete';
import { CityAutoComplete } from 'models/cityAutoComplete';
import CitiesAutoCompleteSearch from 'components/CitiesAutoCompleteSearch';

interface Props {
  show: boolean;
  placeHolder: string;
  country: string;
  onClose: () => void;
  onChange: (city?: CityAutoComplete) => void;
}

const AutoCompleteCitiesSearchContainer = (props: Props) => {
  const dispatch = useDispatch();
  const citiesState = useSelector((state: RootState) => state.citiesAutoComplete);

  const handleSearchChange = _.debounce((value: string) => {

    if (value && value.length > 2) {
      dispatch(searchCitiesAutocomplete(value, props.country));
    }
  }, 250);

  return <CitiesAutoCompleteSearch {...props} {...citiesState} minLengthForSearch={2} onSearchChange={handleSearchChange} />;
};

export default AutoCompleteCitiesSearchContainer;
